import React from 'react';
import { useParams } from 'react-router-dom';
import ListeningQuestions from '../components/Mock/ListeningQuestions';

const ListeningQuestionsPage = () => {
  const { passageId } = useParams();
  const jsonPath = `/data/mock1Listening${passageId}.json`;

  return (
    <ListeningQuestions
      jsonPath={jsonPath}
      onSubmit={(answers) => {
        console.log(`Answers for passage ${passageId}:`, answers);
        // Save to Firestore later
      }}
    />
  );
};

export default ListeningQuestionsPage;
